// Import Third-party Packages
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Import Components
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import Box from '@material-ui/core/Box'
import CardMedia from '@material-ui/core/CardMedia'
import Hidden from '@material-ui/core/Hidden'
import { Link as MuiLink } from '@material-ui/core/'

// Import Assets
import traceImage from '../assets/trace_image.jpg'
import traceLogo from '../assets/trace_logo.png'

// Import Actions & Methods
import { handleSignUp, setAuthError } from '../store/actions/authActions'

class CompanySignUp extends React.PureComponent {
    state = {
        companyName: '',
        phone: '',
        email: '',
        password: '',
        errorCompanyName: '',
        errorPhone: '',
        errorEmail: '',
        errorPassword: ''
    }

    // Handle on Change
    handleOnChange = event => {
        this.setState({ [ event.target.name ]: event.target.value })

        // Set Error empty if exists
        const { authError } = this.props
        const { errorCompanyName, errorPhone, errorEmail, errorPassword } = this.state
        if(event.target.name === 'email' && errorEmail) {
            this.setState({ errorEmail: '' })
        }

        if(event.target.name === 'password' && errorPassword) {
            this.setState({ errorPassword: '' })
        }

        if (event.target.name === 'companyName' && errorCompanyName) {
            this.setState({ errorCompanyName: '' })
        }

        if (event.target.name === 'phone' && errorPhone) {
            this.setState({ errorPhone: '' })
        }

        if(authError) {
            this.props.dispatch( setAuthError('') )
        }
    }      

    // Handle On Submit
    handleOnSubmit = event => {
        event.preventDefault()

        let { companyName, phone, email, password } = this.state

        // Validate Email & Password
        email = email.trim()
        const validateEmail = this._validateEmail(email)
        const validatePassword = this._validatePassword(password)
        const validateCompanyName = this._validateIsEmpty(companyName)
        const validatePhone = this._validateIsEmpty(phone)
        if (validateEmail.success && validatePassword.success && validateCompanyName.success && validatePhone.success) {
            this.props.dispatch( handleSignUp({ companyName, phone, email, password }) )

        } else {
            this.setState({
                errorEmail: validateEmail.message,
                errorPassword: validatePassword.message,
                errorCompanyName: validateCompanyName.message,
                errorPhone: validatePhone.message
            })
        }
    }

    ///////////////////////
    // Utility Functions //
    ///////////////////////

    // Validate email
    _validateEmail = email => {
        email = email.trim()
        const verdict = { success: false, message: '' }

        if (email) {
            if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
                verdict.success = true
                verdict.message = ''

            } else {
                verdict.success = false
                verdict.message = 'Invalid email address.'
            }

        } else {
            verdict.success = false
            verdict.message = 'Required field.'
        }

        return verdict
    }

    // Validate Password
    _validatePassword = password => {
        const verdict = { success: false, message: '' }

        if (password) {
            if (password.length < 6) {
                verdict.success = false
                verdict.message = 'Password must be atleast 6 digit!'

            } else {
                verdict.success = true
                verdict.message = ''
            }

        } else {
            verdict.success = false
            verdict.message = 'Required field.'
        }

        return verdict
    }

    // Validate Company Name && Phone
    _validateIsEmpty = companyName => {
        const verdict = { success: false, message: '' }

        if (companyName) {
            verdict.success = true
            verdict.message = ''
        } else {
            verdict.success = false
            verdict.message = 'Required field.'
        }

        return verdict
    }

    render() {
        const { authError } = this.props
        const { errorCompanyName, errorPhone, errorEmail, errorPassword } = this.state
        
        return (
            <Box
                display='flex'
                flexDirection='row'
                height='100vh'
                width='100%'
                alignItems='center'
                justifyContent='space-evenly'
                overflow='hidden'
            >
                <Hidden smDown={ true }>
                    <Box width='400px' height='400px'>
                        <CardMedia
                            image={ traceImage }
                            style={{ width: '100%', height: '100%' }}
                        />
                    </Box>
                </Hidden>

                <Box // RIGHT BOX (LOGIN PANEL)
                    display='flex'
                    flexDirection='column'
                    width='400px'
                    textAlign='left'
                >
                    <Box width='100%' mb='24px'>
                        <Box width='100%' display='inline-flex' alignItems='center'>
                            <CardMedia image={ traceLogo } style={{ width: '24px', height: '40px', marginBottom: '2px' }} />
                            <Typography component='h1' variant='h3' style={{ marginLeft: '4px' }}>{ 'Trace' }</Typography>
                        </Box>
                    </Box>

                    <Box width='100%'>
                        <Typography component='h2' variant='h5' style={{ fontSize: '30px' }}>{ 'Sign Up.' }</Typography>
                    </Box>

                    { authError &&
                        <Box width='100%'>
                            <Typography variant='caption' style={{ color: '#f44336' }}>{ authError }</Typography>
                        </Box>
                    }

                    <Box width='100%' mt='1rem'>
                        <form onSubmit={this.handleOnSubmit}>
                            <Box marginBottom='1rem'>
                                <Typography variant='h6'>{ 'Company Name' }</Typography>

                                <StyledTextField
                                    error={ authError || errorCompanyName ? true : false }
                                    variant='outlined'
                                    margin='none'
                                    size='small'
                                    fullWidth={ true }
                                    name='companyName'
                                    type='text'
                                    autoComplete='companyName'
                                    onChange={ this.handleOnChange }
                                    helperText={ errorCompanyName ? errorCompanyName : null }
                                    placeholder='Enter your company name here'
                                />
                            </Box>

                            <Box marginBottom='1rem'>
                                <Typography variant='h6'>{ 'Phone' }</Typography>

                                <StyledTextField
                                    error={ authError || errorPhone ? true : false }
                                    variant='outlined'
                                    margin='none'
                                    size='small'
                                    fullWidth={ true }
                                    name='phone'
                                    type='text'
                                    autoComplete='phone'
                                    onChange={ this.handleOnChange }
                                    helperText={ errorPhone ? errorPhone : null }
                                    placeholder='Enter your phone number here'
                                />
                            </Box>

                            <Box marginBottom='1rem'>
                                <Typography variant='h6'>{ 'Email' }</Typography>

                                <StyledTextField
                                    error={ authError || errorEmail ? true : false }
                                    variant='outlined'
                                    margin='none'
                                    size='small'
                                    fullWidth={ true }
                                    name='email'
                                    type='text'
                                    autoComplete='email'
                                    onChange={ this.handleOnChange }
                                    helperText={ errorEmail ? errorEmail : null }
                                    placeholder='Enter your email here'
                                />
                            </Box>

                            <Box marginBottom='1rem'>
                                <Typography variant='h6'>{ 'Password' }</Typography>
                                
                                <StyledTextField
                                    variant='outlined'
                                    margin='none'
                                    size='small'
                                    fullWidth={ true }
                                    name='password'
                                    type='password'
                                    autoComplete='current-password'
                                    onChange={ this.handleOnChange }
                                    error={ authError || errorPassword ? true : false }
                                    helperText={ errorPassword ? errorPassword : null }
                                    placeholder='Enter your password here'
                                />
                            </Box>

                            <StyledButton
                                type='submit'
                                fullWidth={ true }
                                variant='contained'
                            >
                                { 'Sign Up' }
                            </StyledButton>
                        </form>

                        <Box width='100%' display='flex' justifyContent='center' alignItems='center'>
                            <Typography variant='body1' align='center' >
                                { `Already have an account?` }
                            </Typography>

                            <Link to='/login' style={{ textDecoration: 'none', ...attributionLinkStyles, color: '#2ddbac' }}>
                                <Typography
                                    variant='body1' display='block' align='center'
                                >
                                    { ' Log In' }
                                </Typography>
                            </Link>
                        </Box>

                        <Box width='100%' display='flex' justifyContent='center' alignItems='center'>
                            <Typography
                                variant='body2' display='block' align='center' style={ attributionTextStyles }
                            >
                                { 'Developed By | ' }
                            </Typography>

                            <MuiLink href='https://barikoi.com' target='_blank' rel='noopener noreferrer'>
                                <Typography
                                    variant='body2' display='block' align='center' style={ attributionLinkStyles }
                                >
                                    { 'Barikoi Technologies Limited' }
                                </Typography>
                            </MuiLink>
                        </Box>
                    </Box>
                </Box>
            </Box>
        )
    }
}

// JSS Styles
const attributionTextStyles = {
    color: 'rgba(0, 0, 0, 0.8)',
    fontSize: '10px'
}


const attributionLinkStyles = {
    marginLeft: '4px',
    fontSize: '11px'
}

// JSS Styled Components
const StyledTextField = withStyles({
    root: {
        '& .MuiFormLabel-root': { // initial form label color
            color: 'grey'
        },
        '& label.Mui-focused': { // focused form label color
            color: 'black'
        },
        '& .MuiOutlinedInput-root': { // initial outline color
            width: '100%',
            '& fieldset': {
                borderColor: 'rgba(41, 194, 153, 0.8)'
            },
            '&:hover fieldset': {  // hover outline color
                borderColor: 'rgba(41, 194, 153, 1)'
            },
            '&.Mui-focused fieldset': { // focused outline color
                borderColor: 'rgba(41, 194, 153, 0.8)'
            }
        }
    }
})(TextField)

const StyledButton = withStyles({
    root: {
        marginBottom: '1rem',
        boxShadow: 'none',
        backgroundColor: 'rgba(41, 194, 153, 0.8)',
        '&:hover': {
            backgroundColor: 'rgba(41, 194, 153, 1)',
            borderColor: '#0062cc',
            boxShadow: 'none'
        },
        '&:active': {
            boxShadow: 'none',
            backgroundColor: '#0062cc',
            borderColor: '#005cbf'
        },
        '&:focus': {
            boxShadow: '0 0 0 0.2rem rgba(0,123,255,.5)',
        }
    },
    label: {
        paddingTop: '4px',
        color: '#FFFFFF'
    }
})(Button)

const mapStateToProps = state => ({ authError: state.app.auth.error.message })
const mapDispatchToProps = dispatch => ({ dispatch })

export default connect(mapStateToProps, mapDispatchToProps)(CompanySignUp)